var _div, _CloseSmall;
import cn from 'clsx';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlayroomDialogHeader = function PlayroomDialogHeader(_ref) {
  var title = _ref.title,
    _ref$hideClose = _ref.hideClose,
    hideClose = _ref$hideClose === void 0 ? false : _ref$hideClose,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    onClose = _ref.onClose;
  var isDefaultStyle = type === 'default';
  return /*#__PURE__*/_jsxs("header", {
    className: cn(
    // Display
    'tw-flex tw-items-center tw-justify-between tw-px-2.4 tw-py-1.2 sm:tw-py-1.6',
    // Border bottom
    isDefaultStyle && 'tw-border-b tw-border-solid tw-border-b-neutral-light-400 dark:tw-border-b-neutral-dark-700',
    // Fonts
    'dark:tw-text-neutral-light-100'),
    children: [isDefaultStyle ? /*#__PURE__*/_jsx("h4", {
      className: "tw-font-subtitle4",
      children: title
    }) : // Neccesary for elements distribution
    _div || (_div = /*#__PURE__*/_jsx("div", {})), !hideClose && /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onClose,
      "aria-label": "Close",
      children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
        ignoreColor: true,
        size: 24,
        className: "tw-fill-current tw-text-neutral-light-700"
      }))
    })]
  });
};
export default PlayroomDialogHeader;